<template>
    <div class="gray-back" style="padding:.2rem 0 1rem 0">
        <van-form
                @submit="onSubmit"
                @failed="onFailed"
        >
            <van-divider  >确认发票信息</van-divider>  

            <van-cell-group  >

                <van-field
                        v-model="row.fapiao_taitou"
                        :rules="[{ required: true, message: '发票抬头不能为空' }]"
                        label="发票抬头"
                        input-align="right"
                        error-message-align="right"
                        clearable
                        placeholder="请输入发票抬头"
                />
                <van-field
                        v-model="row.fapiao_shuihao"
                        :rules="[{ required: true, message: '税号不能为空' }]"
                        label="税号"
                        :border="false"
                        input-align="right"
                        error-message-align="right"
                        clearable
                        placeholder="请输入税号"
                />
                <div class="operate-desc-left">如果您所在的单位没有纳税人识别号请填写“无”</div>

                <van-field
                        v-model="row.fapiao_address"
                        label="地址"
                        input-align="right"
                        error-message-align="right"
                        clearable
                        placeholder="（非必填）发票购买方地址"
                />
                <van-field
                        v-model="row.fapiao_tel"
                        label="电话"
                        input-align="right"
                        error-message-align="right"
                        clearable
                        placeholder="（非必填）发票购买方电话"
                />
                <van-field
                        v-model="row.fapiao_account"
                        label="开户行及账号"
                        input-align="right"
                        error-message-align="right"
                        clearable
                        placeholder="（非必填）发票购买方开户行及账号"
                />

                <van-field
                        v-model="row.fapiao_beizhu"
                        label="发票备注"
                        input-align="right"
                        clearable
                        placeholder="请输入发票备注"
                />
                <van-field
                        v-model="row.fapiao_email"
                        :rules="[{ validator: validator.email, message: '请输入正确的邮箱' }]"
                        error-message-align="right"
                        label="接收邮箱"
                        input-align="right"
                        clearable
                        placeholder="请输入接收邮箱"
                />
                <van-field
                        v-model="row.fapiao_phone"
                        :rules="[{ required: true,message:'请输入正确的手机号'}]"
                        error-message-align="right"
                        label="接收手机"
                        input-align="right"
                        clearable
                        placeholder="请输入接收手机"
                />

                <!-- <div class="fapiao-tip-wrap">
                    <div v-if="row.order.memberprice > 0">
                        发票金额：{{parseInt(row.order.serviceprice)+parseInt(row.order.otherprice)+parseInt(row.order.memberprice)}}元  名目：{{row._saiqu.fapiaomingxi}}
                    </div>
                  <div v-else>
                    发票金额：{{parseInt(row.order.serviceprice)+parseInt(row.order.otherprice)}}元  名目：{{row._saiqu.fapiaomingxi}}
                  </div>
                </div> -->
                <div style="height: 0.2rem"></div>
                <div style="text-align: center" v-show="false">
                    <van-button
                            style="width: 3rem; margin: 10px;"
                            size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="保存中..." native-type="submit" @click="save">确认发票信息</van-button>
                </div>

            </van-cell-group>  


            <van-divider>费用信息</van-divider>

            <van-cell-group>
                <van-cell
                        v-for="(item,index) in row.list"
                        :key="index"
                        input-align="right"
                        :title="item.service_name"
                        :value="'¥'+item.price +' x '+ item.count"
                />
              <van-cell
                  v-for="(item,index) in row.list"
                  v-if="item.memberprice > 0"
                  :key="index"
                  input-align="right"
                  title="人员费用"
                  :value="'¥'+item.memberprice +' x '+ item.count"
              />
                <van-cell
                        input-align="right"
                        title="费用总计"
                        :value="row.order.total"
                />

            </van-cell-group> 


            <div class="savebtn">
 
                <van-button
                        color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                        style="width: 3rem"
                        size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="submit">保存</van-button>
            </div>
        </van-form>


      <van-action-sheet v-model="payShow" :actions="payActions" @select="onPaySelect" />
      <van-dialog v-model="payOffShow" title="请扫码加入报名群" show-cancel-button :showConfirmButton="false"
      >
        <p style="text-align: center;" :key="wechat_erweiimg_key" v-for="(wechat_erweiimg_url,wechat_erweiimg_key) in row.wechat_erweiimg">
          <img style="width: 70%;" :src="wechat_erweiimg_url"  />
        </p>

        <p  style="text-align: center;margin: 10px 0;">
          <van-button size="normal" type="default" round @click="downloadpic" >下载图片</van-button>
          <van-button size="normal" round @click="onApplySuccess"
                      color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
          >完成报名</van-button>
        </p>
      </van-dialog>
        <PayDialog :show="payDialogShow" scene="huiyi_baoming" :ids="orderIds" @onPayError="onPayError" @onPaySuccess="onPaySuccess"
                   @onPayClose="onPayClose"/>


    </div>
</template>
<style scoped>

    .fapiao-tip-wrap{
        background: #F3F3F3;
        margin: 0.2rem;
        border-radius: 8px;
        line-height: 36px;
        padding: 0.2rem;
        font-size: 14px;
        color: #666;
    }
    .savebtn {
        position: fixed;
        bottom: 0;
        padding-bottom: 0.2rem;
        width: 100%;
        z-index: 10;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
        background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
    }


    .van-tag {
        width: 55px;
        margin-left: 10px;
        text-align: center;
    }
    .between {
        justify-content: space-between;
    }


</style>
<script>
    import Vue from 'vue';
    import area from "../../../utils/area";
    import validator from "../../../utils/validator";
    import PicUploader from '@/components/picker/PicUploader.vue';
    import FileUploader from '@/components/picker/FileUploader.vue';

    import {Cell,Field,Area,Form,Divider, CellGroup,RadioGroup,Radio,ActionSheet,Icon, Toast, Popup, Picker, Sidebar, SidebarItem, Tag, Stepper ,Switch ,Button} from 'vant';
    import CaipanPicker from '@/components/picker/CaipanPicker.vue';
    import FamliyPicker from '@/components/picker/FamliyPicker.vue';

    import PayDialog from '@/components/PayDialog.vue';

    Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(ActionSheet).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
            .use(Switch).use(Button);
    export default {
        name: 'HuiyiApplyFormStep5',
        components: {
            [Field.name]: Field,
            PicUploader,
            PayDialog,
            FileUploader,
        },
        data: function () {
            return {
                validator,
              payShow:false,
              payOffShow:false,
                payDialogShow:false,
                saveLoading:false,
                showArea:false,
                areaList:{},
                areaValue:'',
                submitType:'',
                subjectName:'',
                orderIds:[],
                subjectArray:[],
                subjectOptions:[],
                row:{
                    order:{

                    },
                    _saiqu:{

                    },
                    list:[]
                },
              payActions:[
                { name: '线下汇款转账，显示报名群二维码' },{ name: '在线支付（微信，支付宝）' },
              ],
            }
        },
        filters: {},
        mounted() {
            document.title = '信息补充';

            let that = this;
            that.row.id = this.$route.query.id;
            if(that.row.id){
                this.fetch();
            }
        },
        watch: {
            formData() {
            }
        },
        destroyed() {
        },
        methods: {
            onQuestion(){
                console.log('onQuestion')
            },
            goPre(){
                let that =this;
                rbLink({
                    name:'HuiyiApplyFormStep2',
                    query:{
                        id:that.row.id
                    }
                },'replace')
            },

          downloadpic(){
            let that = this;
            appEvent({
              name: 'downloadPic',
              query: {
                'filename' : 'wechat-img.png',
                'url' : that.row.wechat_erweiimg
              }
            });
          },
          onPaySelect(item,index) {
            // 默认情况下点击选项时不会自动收起
            // 可以通过 close-on-click-action 属性开启自动收起
            this.payShow = false;
            let that =this
            if(index == 1){
              that.$api.post('/api/huiyi/ordersave', that.row, (res) => {
                that.saveLoading = false;

                that.orderIds = res.data.ids;
                that.payDialogShow = true;

              }, (res) => {
                Toast.fail(res.msg);
                that.saveLoading = false;
              })
            }else{
              this.payOffShow = true;
              this.payOffShow = true;
            }
          },

          onApplySuccess() {
              let that =this
            // 更改申报状态
            that.$api.post('/api/huiyi/orderOfflineSave', that.row, (res) => {
              that.saveLoading = false;
              rbLink({
                name:'HuiyiApplyList'
              },'replace')
            }, (res) => {
              Toast.fail(res.msg);
              that.saveLoading = false;
            })
          },

            onSubmit(values){
                console.log('onSubmit-values',values);
                console.log('submitType',this.submitType);

                let that = this;
                console.log(that.formData)
                that.formValidate = true; 

              that.saveLoading = true;
              that.row.is_confirm=1

                that.$api.post('/api/huiyi/ordersave', that.row, (res) => {
                    that.saveLoading = false;
 
                    rbLink({
                        name:'',
                        query:{
                            id: res.data.id
                        }
                    },'back')

                }, (res) => {
                    Toast.fail(res.msg);
                    that.saveLoading = false;
                })
            },
            save(values){
                this.submitType = 'save';
            },
            onFailed(errorInfo){
                console.log('failed', errorInfo);
            },
            submit(values) {
                this.submitType = 'submit';
            },
            fetch(){
                let that = this;
                that.$api.post('/api/huiyi/step5detail', {
                    id:that.row.id
                }, (res) => {
                    that.row = res.data;
                }, (res) => {
                    Toast.fail(res.msg);
                })
            },

            onPayError() {
                let that = this;
                console.log('onPayError 支付失败');
                that.payDialogShow = false;

                that.$toast('支付失败');

                rbLink({
                    name:'HuiyiApplyList'
                },'replace')

            },
            onPaySuccess() {
                let that = this;
                console.log('onPaySuccess 支付成功');


                that.payDialogShow = false;
 
                that.$api.post('/api/huiyi/step5detail', {
                    id:that.row.id
                }, (res) => { 
 
                  if(res.data.memberstatus==6){
                    setTimeout(function () {
                        rbLink({
                            name:'HuiyiApplyFormSuccess',
                            query:{
                                id:that.row.id
                            }
                        },'replace')

                    },500);
                  }else{ 
                    Toast.fail('支付未完成，请重试');
                    setTimeout(function () {
                      rbLink({
                          name:'HuiyiApplyList'
                      },'replace') 
                    },500);
                  }

                }, (res) => {
                    Toast.fail(res.msg);
                })



            },
            onPayClose() {
                let that = this;
                console.log('onPayClose 支付关闭');
                that.payDialogShow = false;



                rbLink({
                    name:'HuiyiApplyList'
                },'replace')
            }


        }
    }
</script>



// WEBPACK FOOTER //
// HuiyiApplyFormStepC5.vue?d2cfea78